export const DETAIL_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.DetailTemplateInterface.DetailTemplate';
